module.exports = __webpack_public_path__ + "media/images/oak/slides/slide-1-mobile-b9077253f63169ed7a836241d8bf9f62.jpg";